import React from "react";
import { Skeleton } from "@mui/material";

/**
 * Stands in for a card that does not exist on screen yet. Content already rendered dims in place
 * instead — swapping populated cards for skeletons is what rediscovery avoids.
 */
const CardSkeleton = ({ height = 96 }: { height?: number }) => (
  <Skeleton variant="rounded" height={height} sx={{ borderRadius: "8px" }} />
);

export default CardSkeleton;
